"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DollarSignCircleOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M7.51 24.49a12 12 0 1117 0 12 12 0 01-17 0M6.1 25.9a14 14 0 100-19.8 14 14 0 000 19.8z"/><path d="M20.75 18.57c0-1.75-1.1-2.74-3.67-3.32l-1.65-.36c-1.41-.36-2-.91-2-1.79s.86-1.57 2.11-1.7a3.2 3.2 0 013 1.47 1.09 1.09 0 001 .64c.56 0 .91-.29.91-.74a1.52 1.52 0 00-.08-.49c-.41-1.29-1.78-2.18-3.62-2.39V9.5a1 1 0 00-2 0v.44c-2.08.35-3.39 1.62-3.39 3.4s1.13 2.78 3.55 3.32l1.61.36c1.61.39 2.21.89 2.21 1.83s-.83 1.68-2.22 1.76a3.45 3.45 0 01-3.26-1.49 1 1 0 00-1-.65c-.6 0-1 .32-1 .85a1.38 1.38 0 00.1.49 3.92 3.92 0 003.35 2.27v.43a1 1 0 002 0v-.38c2.03-.2 4.05-1.22 4.05-3.56z"/>';
var DollarSignCircleOutlineSVG = function DollarSignCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.DollarSignCircleOutlineSVG = DollarSignCircleOutlineSVG;
DollarSignCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(DollarSignCircleOutlineSVG);
exports.default = _default;